import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() =>
  createStyles({
    actionContainer: {
      margin: 5,
    },
  })
);
